import { PushNotifications } from '@capacitor/push-notifications';
import axios from "axios";
import {generateURL} from './config';
import { Capacitor } from '@capacitor/core';
import {userIsLoggedIn} from './users';
import deviceChecker from "@/js/DeviceChecker";
import router from '../router/index';

const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');

export let jumpToLoginApproveAfterLogin = false;

export async function addPushNotificationListeners() {  
    if (!isPushNotificationsAvailable) {
        return false;
    }

    await PushNotifications.addListener('registration', token => {
        console.info('[dh.matrix] Registration token: ', token.value);
        localStorage.setItem('deviceToken', token.value);
    });

    await PushNotifications.addListener('registrationError', err => {
        console.error('[dh.matrix] Registration error: ', err.error);
    });

    await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('[dh.matrix] Push notification received: ', notification);
    });

    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        const data = notification.notification.data;
        if (data?.action === 'open2fa') {
            const intval = setInterval(() => {
                try {
                    if (!router || typeof router.isReady !== 'function') {
                        return;
                    }

                    clearInterval(intval); // innentől nem kell többet pollolni

                    router.isReady().then(() => {
                        if (userIsLoggedIn()) {
                            router.push('/loginRequests');
                        } else {
                            jumpToLoginApproveAfterLogin = true;
                        }
                    });
                } catch (e) {
                    console.log('err', e);
                }
            }, 200);
        }

        console.log('[dh.matrix] Push notification action performed', notification.actionId, notification.inputValue);
    });
}

export async function registerNotifications() {
    if (!isPushNotificationsAvailable) {
        return false;
    }
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
        console.log('[dh.matrix] You cannot receive any notifications!');
    }

    await PushNotifications.register();

    if (Capacitor.getPlatform() === 'android') {
        await PushNotifications.createChannel({
            id: 'auth_channel',
            name: 'Auth',
            importance: 5,
            sound: 'default',
            vibration: true
        });
    }
}

export async function getDeliveredNotifications() {
    const notificationList = await PushNotifications.getDeliveredNotifications ();
    console.log('[dh.matrix] delivered notifications', notificationList);
}

export async function saveDevice() {
    const apiURL = generateURL('saveDevice');
    const selectedIdentity = JSON.parse(localStorage.getItem('selectedIdentity'));
    const user = JSON.parse(localStorage.getItem('loginDatas'));
    const deviceToken = localStorage.getItem('deviceToken');
    let identityId = selectedIdentity.identityId;

    if (user.origIdentity && user.origIdentity.id) {
        identityId = user.origIdentity.id
    }

    console.info('[dh.matrix] deviceToken: '+deviceToken);
    console.info('[dh.matrix] identityId: '+identityId);

    await axios.post(apiURL, {
        identityId: identityId,
        deviceToken: deviceToken,
        deviceId: await deviceChecker.getOrCreateDeviceId()
    }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(async function(response) {
        if (typeof response.data.status != 'undefined') {
            switch (response.data.status) {
                case 'success':
                    console.info('[dh.matrix] Saved token: ', deviceToken);
                    break;

                case 'error':
                    console.info('[dh.matrix] Error: ', response.data.message);
                    break;

                default:
                    console.error('[dh.matrix] Device save error, wrong status arrived: '+response.data.status);
                    break;
            }
        } else {
            console.error('[dh.matrix] Device save error, no status arrived!');
        }
    });
}